export default "__VITE_ASSET__ZwZYeAHC__"